import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import dict from "../../i18n/es-MX";

function Row({ label, value }) {
    return (
        <div className="flex items-center justify-between py-3 border-b border-slate-800 last:border-b-0">
            <span className="text-xs uppercase tracking-wider text-slate-500">{label}</span>
            <span className="text-sm text-slate-100 text-right">{value || dict.common.none}</span>
        </div>
    );
}

export default function OperatorProfile() {
    const { user } = useAuth();
    const role = dict.roles[user?.role] || user?.role;

    return (
        <div data-testid="operator-profile" className="px-4 py-5 space-y-5">
            <h1 className="font-display text-3xl font-extrabold tracking-tight">
                {dict.operator.profileTitle}
            </h1>

            <div className="rounded-2xl border border-slate-800 bg-slate-900/60 overflow-hidden">
                <div className="px-4 py-3 border-b border-slate-800 text-xs uppercase tracking-wider text-slate-400">
                    {dict.operator.accountInfo}
                </div>
                <div className="px-4">
                    <Row label="Nombre" value={user?.full_name || user?.name} />
                    <Row label="Correo" value={user?.email} />
                    <Row label="Teléfono" value={user?.phone} />
                    <Row label="Rol" value={role} />
                </div>
            </div>

            <p className="text-center text-xs text-slate-500">{dict.operator.profileSoon}</p>
        </div>
    );
}
